import styled from 'styled-components';
import { Button, ButtonGroup, Icon } from '@material-ui/core';

export const SelectionButtonGroup = styled(ButtonGroup)`
  margin-top: 42px;
`;

export const SelectionButton = styled(Button)`
  padding-left: 42px;
  padding-right: 42px;

  & > .MuiButton-label {
    display: flex;
    flex-direction: column;
  }
`;

export const SelectionIcon = styled(Icon)`
  font-size: 3rem;
  color: rgba(0, 0, 0, 0.75);
`;
